module.exports = __webpack_public_path__ + "img/madeinusa.373df789.png";